import { createFileRoute } from "@tanstack/react-router";
import { validateSpecSearch } from "../features/specs/search";
import { SpecPage } from "../features/specs/spec-page";

export const Route = createFileRoute("/_app/w/$workspace/p/$project/$kind/$name")({
  validateSearch: validateSpecSearch,
  component: SpecPage,
});
